import { lazyWithRetry } from "utils";

export const NoteManagement = lazyWithRetry(() => import("./containers/index"));
export const CreateNoteTemplate = lazyWithRetry(() => import("./containers/CreateNoteTemplate"));